export default __webpack_public_path__ + "static/media/yuukkelogofordark.17124113.png";